<template>
    <div>
        <sale-dashboard v-if="show"></sale-dashboard>
        <admin-dashboard v-else-if="type === 'admin'"></admin-dashboard>
        <template v-else>
            <h1>欢迎来到轻松艺考</h1>
        </template>
    </div>
</template>

<script>
import AdminDashboard from './AdminDashboard.vue'
import SaleDashboard from './SaleDashboard.vue'

export default {
    name: 'dashboard',
    components: { AdminDashboard, SaleDashboard },
    data() {
        return {
            type: '',
            show: false
        }
    },
    methods: {
        setType() {
            const user = JSON.parse(sessionStorage.getItem('user'))
            if (user.admin) {
                this.type = 'admin'
            } else if (user.sale) {
                this.type = 'sale'
            }
            if (user.userId === 3050164) {
                this.show = true
            }
        }
    },
    mounted() {
        this.setType()
    }
}
</script>

<style lang="less">
.dashborad.container {
    display: flex;
  }
.dashborad {
  .common-title {
    color: #000;
    text-align: left;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 1.3em;
  }
  .dashborad-left {
    flex: 0 0 400px;
    margin-right: 20px;
  }
  .dashborad-main {
    flex: 1;
    .part.line {
      margin-top: 10px;
      display: flex;
    }
    .part-chart {
      flex: 1;
    }
    .part-stat {
      margin-left: 10px;
      flex: 0 0 400px;
    }
    .chart-item {
      margin-bottom: 1em;
    }
  }
  .stat-item {
    margin-bottom: 2em;
  }
  .stat-num-list {
    display: flex;
    .stat-num-item {
      flex: 1;
      .title {
        margin: 0;
      }
    }
    .stat-num-item + .stat-num-item {
      margin-left: 10px;
    }
    .stat-num-item .num {
      padding: 0.5em 0;
    }
  }
  .stat-num-item.bg {
    .el-card {
      background-color: #14AAFF;
      color: #fff;
    }
    .title {
      color: #fff;
    }
    .num {
      color: #fff;
    }
  }
  .dashborad-left {
    .num {
      padding: 1.2em 0;
    }
  }
  .stat-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 1.4em;
    }
  }
  .part-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .common-date {
    text-align: left;
    color: #a9a7a7;
  }
  .num {
    color: #000;
    font-weight: 700;
    font-size: 1.5em;
  }
  .admin-stat-list {
    .admin-stat-item + .admin-stat-item {
        margin-top: 1em;
    }
  }
  .part-content {
    .num-list {
        display: flex;
    }
    .num-item {
        flex: 1;
        color: #fff;
        padding: 1em 0;
        border-radius: 5px;
        background-color: rgb(20, 170, 255);
    }
    .num-item + .num-item  {
        margin-left: 1em;
    }
    .num {
        color: #fff;
    }
  }
  .part + .part {
    margin-top: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Manager/Sys/Dashboard.vue